import { render } from "./index.vue?vue&type=template&id=7f76fc82"
import script from "./index.vue?vue&type=script&lang=ts"
export * from "./index.vue?vue&type=script&lang=ts"

import "./index.vue?vue&type=style&index=0&id=7f76fc82&lang=css"
script.render = render

export default script